{
 "background_workers": 1,
 "file_watcher_port": 6788,
 "frappe_user": "caratred",
 "gunicorn_workers": 9,
 "live_reload": true,
 "rebase_on_pull": false,
 "redis_cache": "redis://127.0.0.1:13001",
 "redis_queue": "redis://127.0.0.1:11001",
 "redis_socketio": "redis://127.0.0.1:13001",
 "restart_supervisor_on_update": true,
 "restart_systemd_on_update": false,
 "serve_default_site": true,
 "shallow_clone": true,
 "socketio_port": 9001,
 "use_redis_auth": false,
 "webserver_port": 8001
}